import { useContext } from 'react'

import { AccountFormContext } from '../context'

export function usePeople() {
  const {
    people,
    loadingPeople: loading,
    listPeople
  } = useContext(AccountFormContext)

  return {
    people,
    loading,
    listPeople
  }
}
